function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

async function requestSuccess({getState, dispatch, getSourceAction}, req) {
    let vss_id = getCookie('vss_id');
    let vss_hash = getCookie('vss_hash');
    let isDisconnected = sessionStorage.getItem('disconnected');
    if (!!vss_id && !!vss_hash && !isDisconnected){
        req.headers['x-vss-id'] = vss_id;
        req.headers['x-vss-hash'] = vss_hash;
    }
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    if (token != null) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
}

async function responseSuccess({getState, dispatch, getSourceAction}, req) {

    if (req.data && req.data && req.data.token) {
        // console.log("token", process.env.REACT_APP_TOKEN_NAME, process.env);
        await localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, req.data.token);

    }
    return req;
}

export default {
    request: {
        success: requestSuccess
    },
    response: {
        success: responseSuccess
    }
}
